<template>

<div class="wardrobes">

  <div class="wardrobe">

    <p v-if="!enablePromoCode"><small><button @click.stop.prevent="enablePromoCode = true;" style="text-decoration: underline; color: #1da1e4;">Enter your promo code</button></small></p>
    <div class="wardrobe-inner" v-if="enablePromoCode">

      <div class="wardrobe-main l_p0 l_wrap">

        <div class="wardrobe-cost l_promocode" :class="{ 's_active' : builder.quote.promoCodeApplied }">
          <label for="promoCode" class="wardrobe-cost-label">Promo Code</label>
          <div class="wardrobe-cost-input">
            <input
            type="text"
            id="promoCode"
            name="promoCode"
            placeholder="Enter your code here"
            v-model="promoCodeInput"
            @focus="$event.target.select()"
            @keydown.enter.prevent="updatePromoCode($event)"
            aria-required
            autocomplete="off">
            <div class="feedback" v-if="promoCodeResponse || builder.quote.promoCodeApplied">
              <template v-if="builder.quote.promoCodeApplied">
                <svg class="icon"><use href="#check"></use></svg>
                Valid
              </template>
              <template v-else>
                Invalid
              </template>
            </div>
            <button class="button l_base l_strong" @click.stop="updatePromoCode($event)">Check</button>
          </div>
        </div>

      </div>

    </div>
  </div>

</div>

</template>

<script setup>

import { ref, onMounted } from 'vue'

var _ = require('lodash');

const enablePromoCode = ref(false);
const promoCodeInput = ref('');
const promoCodeResponse = ref('');

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

onMounted(() => {

  promoCodeInput.value = builder.quote.promoCode;
  if (builder.quote.promoCode && builder.quote.promoCode.length) enablePromoCode.value = true;

});

function updatePromoCode() {
  let submitData = {
    'promoCode': promoCodeInput.value,
    'promoCodeCheck' : true
  };
  builder.actionPost('quote/update', submitData, false).then(response => {
    if (_.isObject(response)) {
      builder.isSubmitted = false;
      builder.$patch((state) => {
        state.quote = response.quote;
      })
      promoCodeResponse.value = response.response;
    }
  });
}

</script>
